import * as actionTypes from './actionTypes';

export const appSetTheme = (theme) => ({
    type: actionTypes.APP_SET_THEME,
    theme: theme
})